import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MatrixRain from './app/components/MatrixRain';
import Header from './app/components/Header';
import Footer from './app/components/Footer';
import Home from './app/views/Home';
import Projects from './app/views/Projects';
import About from './app/views/About';
import PageNotFound from './app/views/PageNotFound';
import en from './assets/locales/en.json';
import ru from './assets/locales/ru.json';
import ua from './assets/locales/ua.json';

const locales = { en, ru, ua };

function App() {
  const [lang, setLang] = useState('en');
  const [t, setT] = useState(locales[lang]);

  useEffect(() => {
    setT(locales[lang]);
  }, [lang]);

  return (
    <Router>
      <MatrixRain />
      <div className="App">
        <Header t={t.header} setLang={setLang} lang={lang} />
        <div className="container content">
          <Routes>
            <Route path="/" element={<Home t={t.pages.home} locale={t} />} />
            <Route path="/projects" element={<Projects t={t.pages.projects} locale={t} />} />
            <Route path="/about-me" element={<About t={t.pages.about} locale={t} />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
        <Footer t={t.footer} />
      </div>
    </Router>
  );
}

export default App;
